import { render, staticRenderFns } from "./customershopaddress.vue?vue&type=template&id=513e1e9b"
import script from "./customershopaddress.vue?vue&type=script&lang=js"
export * from "./customershopaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports